/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Payee } from '@root/api/ump-catalog-manager'
import { countryClickGtm, payClickGtm, voucherSumClickGtm } from '@shared/lib/gtm'

export const invokeGtmPaymentEvent = (
  showVouchersForm: boolean,
  activeCountry: string,
  defaultCountry: string,
  activeCountrySteam: string,
  defaultCountrySteam: string,
  activeDenomination: Payee,
  defaultVoucher: Payee,
  linkedTsp: Payee,
  activeService: Payee,
  requestID: string,
  amount: string,
  paymentMethod: string,
  pcekMdOrder: string
) => {
  if (showVouchersForm) {
    if (activeCountry === defaultCountry) {
      // @ts-ignore
      countryClickGtm(linkedTsp?.providerName || activeService?.providerName, defaultCountry || null)
    }

    if (activeDenomination?.serviceId === defaultVoucher?.serviceId) {
      voucherSumClickGtm(
        linkedTsp?.providerName || activeService?.providerName,
        defaultVoucher?.features?.buttonLabel as string
      )
    }

    payClickGtm(
      linkedTsp?.providerName || activeService?.providerName,
      paymentMethod === 'SBP' ? requestID : pcekMdOrder,
      amount,
      paymentMethod
    )
  }

  if (!showVouchersForm) {
    if (activeCountrySteam === defaultCountrySteam) {
      countryClickGtm(activeService?.providerName, defaultCountrySteam)
    }

    payClickGtm(activeService?.providerName, paymentMethod === 'SBP' ? requestID : pcekMdOrder, amount, paymentMethod)
  }
}
